import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Shop } from '@app/services/shops/shop.model';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';
import { TrackingPageService } from '../../../tracking-page.service';
@Component({
  selector: 'tracking-page-tracking-details',
  templateUrl: './tracking-page-tracking-details.component.html',
  styleUrls: ['./tracking-page-tracking-details.component.scss', '../../../tracking-page.component.scss'],
  standalone: false,
})
export class TrackingPageTrackingDetailsComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() shop: Shop;
  carrierOptions: DropdownOption[] = [];
  defaultCarrierOptions: DropdownOption[] = [];
  constructor(
    private trackingPageService: TrackingPageService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  initCarriersDropdown() {
    const selectedCarriers = this.formGroup.get('widgets.details.carriersToDisplayMessageFor')?.value;

    this.trackingPageService.getCarrierOptions().subscribe((carriers) => {
      this.carrierOptions = [
        {
          label: 'All Untracked Carriers',
          value: 'all_untracked_carriers',
          checked: selectedCarriers?.includes('all_untracked_carriers'),
        },
        ...carriers.map((carrier) => ({
          label: carrier.label,
          value: carrier.value,
          checked: selectedCarriers?.includes(carrier.value),
        })),
      ];

      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnInit(): void {
    this.initCarriersDropdown();
  }
}
